import React, { useState, useEffect } from 'react';
import VouchersForm from './VouchersForm';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Vouchers, putAPI_Update_Vouchers, gAPI_Vouchers_By_Id } from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import BuyOption from './BuyoptionForm';
import InviteVoucher from './InviteVoucher';
import ShowInvitations from './ShowInvitations';
import SellVoucher from './SellVoucher';
function CreateVouchersForm({ propertyId, LoadData, email, ShowInviteVoucher, inviteVoucher, propertydata, userData, voucherList, isBuyOption, locale, invitation, voucherId }) {
  const [visible, setVisible] = useState(false);
  const [buyOptionvisible, setbuyOptionVisible] = useState(false);
  const [voucher, setVoucher] = useState('');

  const [sellVoucher, setSellVoucher] = useState(false);
  const [showInvitations, setShowInvitations] = useState(false);
  const handleSubmit = (data) => {
    if (!buyOptionvisible) {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Vouchers}`,
        data,
      })
        .then((m) => {
          LoadData();

          setVisible(!visible);

        })
    } else {

      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Vouchers}/${voucherId}`,
        data: data,
      }).then(() => {
        LoadData();
        setbuyOptionVisible(!buyOptionvisible);
      });
    }
  };
  return (
    <div>
      <div className="row"><div className='col-md-12'>
        {!isBuyOption && <Button
          color="primary"
          outline
          size="xs"
          onClick={() => {
            setVisible(!visible);
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Create a voucher
        </Button>}
        {isBuyOption && <Button
          color="primary"
          outline
          size="xs"
          onClick={() => {
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_Vouchers_By_Id}/${voucherId}`,
            })
              .then((res) => {
                setVoucher(res.data);
                setbuyOptionVisible(!buyOptionvisible);
              })
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Create a New BuyOption
        </Button>}
      </div>
      </div>
      <div className="row mt-2"><div className='col-md-12 '>
        {!isBuyOption && <Button
          color="primary"
          outline
          size="xs"
          onClick={() => {
            ShowInviteVoucher(!inviteVoucher);
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Invite a business to sell your vouchers
        </Button>}
      </div>
        {/* <div className='col-md-6'>
          {!isBuyOption && <Button
            color="primary"
            outline
            size="xs"
            onClick={() => { setSellVoucher(!sellVoucher); }}
            style={{ width: '100%', borderRadius: '6px' }}
          >
            + Sell a 3<span className='mb-2'>rd</span> Party  Voucher
          </Button>}
        </div> */}
      </div>
      <VouchersForm
        formLabel="Create a New Voucher"
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        inviteVoucher={inviteVoucher}
        ShowInviteVoucher={ShowInviteVoucher}
        propertyId={propertyId}
      />
      {
        buyOptionvisible && isBuyOption && <BuyOption
          formLabel="Create a New Voucher Buy Option"
          visible={buyOptionvisible}
          toggle={() => {
            setbuyOptionVisible(!buyOptionvisible);
          }}
          update={false}
          LoadData={LoadData}
          id={voucherId}
          submit={handleSubmit}
          updateVoucherData={voucher}
          propertyId={propertyId}
        />
      }
      {
        inviteVoucher && <InviteVoucher propertyId={propertyId}
          isvisible={inviteVoucher} locale={locale}
          userData={userData}
          propertydata={propertydata}
          voucherList={voucherList}
          email={email}
          toggle={() => ShowInviteVoucher(!inviteVoucher)}
        />
      }
      {/* {
        sellVoucher && <SellVoucher propertyId={propertyId}
          isvisible={sellVoucher} locale={locale}
          userData={userData}
          propertydata={propertydata}
          voucherList={voucherList}
          email={email}
          toggle={() => setSellVoucher(!sellVoucher)}
        />
      } */}
    </div >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreateVouchersForm));

// CreatePromosForm.propTypes = {
//   propertyId: PropTypes.string.isRequired,
// };
